import bramidanPrivacyNotice from 'assets/privacy-notice/bramidan_privacy_notice_V1.pdf';
import React, { FC, useState } from 'react';
import { upsertUserSettings } from 'state/ducks/user-settings/operations';
import { localized } from 'state/i18n';
import { useAppDispatch, useAppSelector } from 'utilities/hooks';
import { Spinner } from 'view/components/spinner/spinner';
import BiButton from 'view/shared/components/buttons/bi-button/bi-button';
import { PdfViewerDialog } from 'view/shared/components/dialogs/pdf-viewer-dialog/pdf-viewer-dialog';

export const PrivacyNotice: FC = React.memo(() => {
	const dispatch = useAppDispatch();
	const userSettings = useAppSelector(state => state.userSettingReducer.userSettings);

	const [showConfirmSpinner, setShowConfirmSpinner] = useState(false);

	const handleConfirm = async () => {
		setShowConfirmSpinner(true);
		(await upsertUserSettings({ ...userSettings, agreedToPrivacyNotice: true }))(dispatch);
	};

	return (
		<PdfViewerDialog
			pdfUrl={bramidanPrivacyNotice}
			title={localized('AgreeToPrivacyNotice')}
			visible={true}
			onHide={() => {}}
			dismissable={false}
			actionButton={
				<BiButton onClick={handleConfirm} containerTheme="slim-with-rounded-corners" colorTheme="org-green">
					{showConfirmSpinner ? (
						<Spinner
							shouldOverlay={false}
							spinnerSize="spinner-container-1-4th-size"
							useMarginsForCorrectingCentering={false}
						/>
					) : (
						localized('Confirm')
					)}
				</BiButton>
			}
		/>
	);
});
